var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog',{ref:"notice",staticClass:"maintenance-notice",style:({
    position: 'fixed',
    inset: '0',
    boxSizing: 'border-box',
    width: 'min(500px, calc(100vw - 32px))',
    maxWidth: 'none',
    maxHeight: 'calc(100dvh - 32px)',
    margin: 'auto',
    padding: '0',
    overflowX: 'hidden',
    overflowY: 'auto',
    border: 'none',
    borderRadius: '16px',
    backgroundColor: '#ffffff',
    color: '#1e293b',
    fontFamily: 'inherit',
    boxShadow: '0 24px 70px rgba(15, 23, 42, 0.25)',
    opacity: '1',
  }),attrs:{"aria-labelledby":"maintenance-title","aria-describedby":"maintenance-description"},on:{"cancel":function($event){$event.preventDefault();},"close":_vm.openNotice}},[_c('div',{style:({
      height: '5px',
      background: 'linear-gradient(90deg, #3848CB, #8792F0)',
    })}),_c('div',{style:({
      padding: 'clamp(20px, 5vw, 30px)',
    })},[_c('div',{style:({
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: '24px',
      })},[_c('div',{style:({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '58px',
          height: '58px',
          flexShrink: '0',
          borderRadius: '15px',
          backgroundColor: '#EEF0FF',
          color: '#3848CB',
        })},[_c('svg',{attrs:{"width":"28","height":"28","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M7 7h14"}}),_c('path',{attrs:{"d":"m17 3 4 4-4 4"}}),_c('path',{attrs:{"d":"M17 17H3"}}),_c('path',{attrs:{"d":"m7 13-4 4 4 4"}})])])]),_c('div',{style:({ marginBottom: '24px' })},[_c('h2',{style:({
          margin: '0 0 12px',
          padding: '0',
          color: '#0f172a',
          fontSize: '22px',
          fontWeight: '700',
          lineHeight: '1.4',
          letterSpacing: '-0.3px',
        }),attrs:{"id":"maintenance-title"}},[_vm._v(" We're Moving to a New Meeting Room Booking Portal. ")]),_c('p',{style:({
          margin: '0',
          padding: '0',
          color: '#64748b',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.8',
        })},[_vm._v(" We are migrating to a new meeting room booking portal. Please use the new portal to book and manage your meeting rooms. ")])]),_c('div',{style:({
        padding: '20px',
        border: '1px solid #C8CEFA',
        borderRadius: '12px',
        backgroundColor: '#EEF0FF',
      }),attrs:{"id":"maintenance-description"}},[_c('div',{style:({
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '12px',
        })},[_c('svg',{style:({ flexShrink: '0' }),attrs:{"width":"19","height":"19","viewBox":"0 0 24 24","fill":"none","stroke":"#2938AC","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10"}}),_c('path',{attrs:{"d":"M12 16v-4"}}),_c('path',{attrs:{"d":"M12 8h.01"}})]),_c('span',{style:({
            color: '#2938AC',
            fontSize: '14px',
            fontWeight: '700',
            lineHeight: '1.5',
          })},[_vm._v(" Meeting Room Booking Portal Migration Notice ")])]),_c('p',{style:({
          margin: '0',
          padding: '0',
          color: '#475569',
          fontSize: '13px',
          fontWeight: '400',
          lineHeight: '1.85',
        })},[_vm._v(" Kindly note that the current meeting room booking portal has been discontinued and will be shut down soon. Please go to meeting.ihextar.com for all meeting room bookings moving forward. ")])]),_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: '12px',
        marginTop: '28px',
        paddingTop: '24px',
        borderTop: '1px solid #e2e8f0',
      })},[_c('a',{style:({
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '9px',
          boxSizing: 'border-box',
          minHeight: '44px',
          margin: '0',
          padding: '11px 20px',
          border: '1px solid',
          borderColor: _vm.primaryButtonHover ? '#2938AC' : '#3848CB',
          borderRadius: '9px',
          backgroundColor: _vm.primaryButtonHover ? '#2938AC' : '#3848CB',
          color: '#ffffff',
          fontFamily: 'inherit',
          fontSize: '14px',
          fontWeight: '600',
          lineHeight: '20px',
          textAlign: 'center',
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          boxShadow: _vm.primaryButtonHover
            ? '0 6px 16px rgba(56, 72, 203, 0.30)'
            : '0 3px 8px rgba(56, 72, 203, 0.18)',
          transform: _vm.primaryButtonHover
            ? 'translateY(-1px)'
            : 'translateY(0)',
          transition: 'all 0.2s ease'
        }),attrs:{"href":"https://meeting.ihextar.com/","target":"_blank","rel":"noopener noreferrer"},on:{"mouseenter":function($event){_vm.primaryButtonHover = true},"focus":function($event){_vm.primaryButtonHover = true},"mouseleave":function($event){_vm.primaryButtonHover = false},"blur":function($event){_vm.primaryButtonHover = false}}},[_c('span',[_vm._v("Go to New Portal")]),_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M7 17 17 7"}}),_c('path',{attrs:{"d":"M8 7h9v9"}})])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }